import * as actions from './actionsTypes';

const initialState = {
  isLoadingCalendarHoidays: false,
  calendarHolidays: [],
  calendarHolidaysFail: null
};

// Reducer de User_Calendar_Events
const calendarHolidaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.IS_LOADING_CALENDAR_HOLIDAYS:
      return {
        ...state,
        isLoadingCalendarHoidays: action.payload
      };
    
    case actions.GET_CALENDAR_HOLIDAYS:
      return {
        ...state,
        calendarHolidays: action.payload
      };
    
    case actions.FAIL_CALENDAR_HOLIDAYS:
      return {
        ...state,
        calendarHolidaysFail: action.payload
      };
    
    default:
      return state;
  }
};

export default calendarHolidaysReducer;